<template>
  <div class="aziendaextra" style="margin: 20px">
    <v-card>
      <!-- Toolbar. -->
      <v-toolbar dense color="primary" dark align="center">
        <v-row class="mt-4">
          <!-- Titolo. -->
          <v-col cols="3" class="mt-1" align="left">
            <v-toolbar-title>Gestione Azienda Extra</v-toolbar-title>
          </v-col>

          <!-- Filtro ricerca. -->
          <v-col cols="3" align="left">
            <v-text-field solo light dense clearable
            append-icon="mdi-magnify" placeholder="Ricerca" v-model="filtro_desc"/>
          </v-col>

          <!-- Pulsante salvataggio. -->
          <v-col class="mt-1" cols="1">
            <v-btn small light @click="setAziendeExtra">
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </v-col>

          <!-- Aggiungi azienda extra. -->
          <v-col class="mt-1" cols="1">
            <v-btn small light @click="apriDettaglio(null)">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </v-col>

          <!-- Refresh lista. -->
          <v-col class="mt-1" cols="3" align="right">
            <v-btn small light @click="getAziendaExtra">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>

          <!-- Pulsante indietro. -->
          <v-col cols="1" class="mt-1" align="right">
            <v-btn small light @click="$router.push('/home/amministrazione')">
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-container>
        <v-data-table
          class="aziendaextra"
          :key="render"
          :headers="headers_azienda_extra"
          :items="lista_azienda_extra"
          :custom-filter="filtraAziendaExtra"
          :search="filtro_desc"
        >
          <!-- Icona predefinito. -->
          <template v-slot:[`item.predefinito`]="{ item }">
            <v-icon :color="item.predefinito ? 'success' : 'error'">
              {{ item.predefinito ? "mdi-check" : "mdi-close" }}
            </v-icon>
          </template>

          <!-- Pulsante modifica. -->
          <template v-slot:[`item.modifica_btn`]="{ item }">
            <v-btn small :disabled="item.validita != 1" @click="apriDettaglio(item)">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>

          <!-- Pulsante disattiva. -->
          <template v-slot:[`item.rimuovi_btn`]="{ item }">
            <v-btn small @click="item.validita = !item.validita">
              <v-icon color="error">{{
                item.validita == 0 ? "mdi-delete-restore" : "mdi-delete"
              }}</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-dialog persistent v-model="dialog_dettaglio">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-row align="center" dark>
            <!-- Titolo dialog. -->
            <v-col cols="5" align="left">
              <v-toolbar-title>{{azienda_extra_sel ? "Modifica azienda extra" : "Nuovo azienda extra"}}</v-toolbar-title>
            </v-col>

            <!-- Pulsante salvataggio modifiche dialog. -->
            <v-col cols="2">
              <v-btn small light @click="salvaDettaglio">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </v-col>

            <!-- Pulsante annulla modifiche. -->
            <v-col cols="5" align="right">
              <v-btn small light @click="dialog_dettaglio = false">
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-container>
            <v-row>
              <v-col cols="1">
                <v-checkbox label="Pred." v-model="azienda_extra_sel.predefinito"/>
              </v-col>
              <v-col cols="3">
                <v-text-field label="Codice" v-model="azienda_extra_sel.codice"/>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Descrizione" v-model="azienda_extra_sel.descrizione"/>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Descrizione secondaria" v-model="azienda_extra_sel.descrizione_bis"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field label="Valore intero" v-model="azienda_extra_sel.val_int"/>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Valore double" v-model="azienda_extra_sel.val_dbl"/>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Valore stringa" v-model="azienda_extra_sel.val_txt"/>
              </v-col>
            </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Overlay caricamento. -->
    <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati">
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar. -->
    <v-snackbar
      dark
      :color="alert.error == true ? 'error' : 'light-green darken-2'"
      v-model="alert.show"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="alert.show = false">Chiudi</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "GestioneAziendaExtra",
  data() {
    return {
      // Variabili di supporto.
      alert: {
        show: false,
        message: null,
        error: false,
      },
      azienda_extra_sel_idx: null,
      azienda_extra_sel: {
          id_azienda_extra: -1,
          codice: null,
          descrizione: null,
          descrizione_bis: null,
          val_txt: null,
          val_dbl: null,
          val_int: null,
          validita: 1,
          predefinito: 0
        },
      caricamento_dati: false,
      filtro_desc: "",
      render: 0,

      // Modali.
      dialog_dettaglio: false,

      // Array.
      headers_azienda_extra: [
        { text: null, value: "modifica_btn", sortable: false, align: "left" },
        { value: "predefinito", text: "Pred." },
        { value: "codice", text: "Codice" },
        { value: "descrizione", text: "Descrizione" },
        { value: "descrizione_bis", text: "Descrizione secondaria" },
        { value: "val_int", text: "Valore intero" },
        { value: "val_dbl", text: "Valore double" },
        { value: "val_txt", text: "Valore stringa" },
        { text: null, value: "rimuovi_btn", sortable: false, align: "right" },
      ],
      lista_azienda_extra: [],
    };
  },

  mounted() {
    this.getAziendaExtra();
  },

  methods: {
    apriDettaglio(item) {
      if(item) {
        this.azienda_extra_sel_idx = this.lista_azienda_extra.indexOf(item);
        this.azienda_extra_sel = Object.assign({}, item);
      } else {  
        this.azienda_extra_sel =  {
          id_azienda_extra: -1,
          codice: null,
          descrizione: null,
          descrizione_bis: null,
          val_txt: null,
          val_dbl: null,
          val_int: null,
          validita: 1,
          predefinito: 0
        }
      }

      this.dialog_dettaglio = true;

    },

    filtraAziendaExtra(value, query, item) {
      if(!item.codice) item.codice = "";
      if(!item.descrizione) item.descrizione = "";
      if(!item.descrizione_bis) item.descrizione_bis = "";
      if(!item.val_txt) item.val_txt = "";

      return (!this.filtro_desc) | item.codice.toLowerCase().includes(this.filtro_desc.toLowerCase()) |
                                   item.descrizione.toLowerCase().includes(this.filtro_desc.toLowerCase()) |
                                   item.descrizione_bis.toLowerCase().includes(this.filtro_desc.toLowerCase()) |
                                   item.val_txt.toLowerCase().includes(this.filtro_desc.toLowerCase()) ;
    },

    getAziendaExtra() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getaziendaextra",
          token: localStorage.user_token,
        },
      };
      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
            this.caricamento_dati = false;

            this.lista_azienda_extra = res.data.result.azienda_extra
              ? res.data.result.azienda_extra
              : [];
            this.alert = {
              message: "Dati caricati con successo.",
              show: true,
              error: false,
            };
          
        })
        .catch((err) => {
          this.caricamento_dati = false;
          this.alert = {
            message: "Errore nella chiamata: " + err,
            show: true,
            error: true,
          };
        });
    },
    
    salvaDettaglio() {
      if(this.azienda_extra_sel.id_azienda_extra == -1) {
        this.lista_azienda_extra.push(this.azienda_extra_sel);
      } else {
        this.lista_azienda_extra[this.azienda_extra_sel_idx] = Object.assign({}, this.azienda_extra_sel);
      }
      this.dialog_dettaglio = false;
      this.render = !this.render;
    },
  
    setAziendeExtra() {
      let request = {
        controller: "Modulo",
        method: "PUT",
        richiesta: {
          action: "setaziendaextra",
          token: localStorage.user_token,
          azienda_extra: this.lista_azienda_extra,
        }
      };

      this.caricamento_dati = true;
      this.$store
      .dispatch("api", request)
      .then(() => {
        this.caricamento_dati = false;
        this.alert = {
          message: "Dati salvati con successo.",
          show: true,
          error: false,
        };
        this.getAziendaExtra();
      })
      .catch((err) => {
        this.caricamento_dati = false;
        this.alert = {
          message: "Salvataggio fallito: " + err,
          show: true,
          error: true,
        };
      });
    },
  },
};
</script>

<style>
.aziendaextra th,
.aziendaextra td {
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Overlay */
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
/* *** */
</style>
